import React, { Component } from 'react'
import { connect } from 'react-redux'
import Menu from 'react-burger-menu/lib/menus/slide'
import { withTranslation } from 'react-i18next'
import { organizationActions } from 'srcReact/OrganizationPage'
import UnauthorizedSideMenu from './components/UnauthorizedSideMenu'
import AuthorizedSideMenu from './components/AuthorizedSideMenu'

class SideBarMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orgaSideBarOpened: false
    }
    this.toggleOrgaSideBar = this.toggleOrgaSideBar.bind(this)
    this.closeOrgaSideBar = this.closeOrgaSideBar.bind(this)
  }

  isMenuOpen(state) {
    return state.isOpen
  }

  toggleOrgaSideBar() {
    this.setState((prevState) => ({
      orgaSideBarOpened: !prevState.orgaSideBarOpened
    }))
  }

  closeOrgaSideBar() {
    this.setState({ orgaSideBarOpened: false })
  }

  render() {
    const { t, user, loggedIn, current_organization, organization_list, conversation, header } = this.props
    const { orgaSideBarOpened } = this.state
    const isAuthorizedUser = user && loggedIn

    return (
      <Menu
        className={loggedIn ? 'menu' : 'menuLogout'}
        isOpen={this.props.isOpen}
        onStateChange={isAuthorizedUser ? this.props.onStateChange : this.isMenuOpen}
        customBurgerIcon={false}
        customCrossIcon={false}
        width={isAuthorizedUser ? '90%' : '60%'}
        styles={{ bmOverlay: { zIndex: 1099 } }}>
        {isAuthorizedUser ? (
          <AuthorizedSideMenu
            isOpen={this.props.isOpen}
            sidebar={header?.sidebar}
            current_organization={current_organization}
            user={user}
            t={t}
            orgaSideBarOpened={orgaSideBarOpened}
            organization_list={organization_list}
            clickAction={this.props.clickAction}
            switchOrganization={this.props.switchOrganization}
            toggleOrgaSideBar={this.toggleOrgaSideBar}
            closeOrgaSideBar={this.closeOrgaSideBar}
            conversations={conversation.list}
            groups_mixrs={header?.notifications?.groups_mixrs || []}
            user_properties={header && header.user_properties}
            notificationCount={this.props.notificationCount}
          />
        ) : (
          <UnauthorizedSideMenu t={t} clickAction={this.props.clickAction} handleLink={this.props.handleLink} />
        )}
      </Menu>
    )
  }
}

function mapStateToProps(state) {
  const { login, organization, common, messenger } = state
  const { current_organization, organization_list, header } = organization
  const { conversation } = messenger
  const { user, loggedIn } = state.login
  return { user, loggedIn, current_organization, organization_list, conversation, header }
}

const actionCreators = {
  switchOrganization: organizationActions.switchOrganization
}

const ExtendedComponent = withTranslation('common')(SideBarMenu)

const connectedSideBarMenu = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedSideBarMenu as SideBarMenu }
